import { render, staticRenderFns } from "./PopupInstallation.vue?vue&type=template&id=33789037&scoped=true&"
import script from "./PopupInstallation.vue?vue&type=script&lang=js&"
export * from "./PopupInstallation.vue?vue&type=script&lang=js&"
import style0 from "./PopupInstallation.vue?vue&type=style&index=0&id=33789037&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33789037",
  null
  
)

export default component.exports